import sanityClient from '@sanity/client'

export default sanityClient({
    projectId: '8rgqlktn',
    dataset: 'production'
})